import React, { useMemo } from "react";
import {
  ObjectStatusCssClasses,
  ObjectStatusTitles,
  ObjectDeletedTitles,
  ObjectActiveTitles
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";

const setRow = (row) => {
  if (row.requiredCompleteRegisteration === undefined || row.requiredCompleteRegisteration === null
    || row.requiredCompleteRegisteration === 0 || row.requiredCompleteRegisteration === false) {
    return (
      <span className={`label label-lg label-light-danger label-inline`} >
        {"ندارد"}
      </span >
    )
  }
  else {
    return (
      < span className={`label label-lg label-light-success label-inline`} >
        {"دارد"}
      </span >
    )
  }
}

export const RequiredCompleteColumnFormatter = (cellContent, row) => setRow(row);
